import React from 'react';
import {Prompt, withRouter} from 'react-router-dom';

import http from 'api/http';
import { componentAPI } from 'api/requests';

import Header from './Header';
import GeneralInformation from './GeneralInformation';
import NotesSection from './Notes';
import FilePicker from 'Components/FilePicker';
import NotificationManager from 'dom-managers/notification';
import Modal from 'Components/Modal';
import Button, { buttonType, buttonColor } from 'Components/Button';
import ApplicationActions from 'Components/ApplicationActions';
import { STATUS } from 'constants/index';
import FamilyInfo from './FamilyInfo';

@withRouter
export default class EditApplication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      description: props.description,
      notes:props.notes,
      family:props.family,
      componentTypeFieldValues:props.componentTypeFieldValues,
      componentTestReports:props.componentTestReports,
      isModalOpen: false,
      requestInProcess: false,
      inputErrors:{},
    };

    this.filesIdsToDelete = [];
    this.someDataWasInputted = false;
    this.requiredFields = ['description'];
    this.componentHadFamily = !!this.props.family;
  }

  componentDidUpdate(prevProps) {
    if (this.props.description && this.state.description === undefined) {
      this.componentHadFamily = !!this.props.family;
      this.setState({
        description: this.props.description,
        notes: this.props.notes,
        family: this.props.family,
        componentTypeFieldValues: this.props.componentTypeFieldValues,
        componentTestReports: this.props.componentTestReports,
      })
    }
  }

  isUserCanEdit = () => {
    const {user, applicationStatus} = this.props;

    return user.isInternal() || applicationStatus === STATUS.INCOMPLETE;
  };

  handleSubmitClick = () => {
    const {description, componentTypeFieldValues, componentTestReports, family, notes} = this.state;
    const {match, updateComponentListEntry, user} = this.props;
    const {applicationId} = match.params;

    if (this.someDataWasInputted) {
      this.validateForm()
        .then(() => {
          const requestJSON = {};
          requestJSON.description = description;
          requestJSON.fieldValues = componentTypeFieldValues.map(field => ({
            fieldId: field.componentTypeFieldId,
            value: field.componentTypeFieldValue
          }));
          requestJSON.notes = notes;
          requestJSON.filesIdsToDelete = this.filesIdsToDelete;
          requestJSON.componentFamilyId = family ? family.id : null;

          const data = new FormData();
          data.append('requestJson', JSON.stringify(requestJSON));
          componentTestReports.filter(file => !file.created).forEach(file => data.append('reports', file));

          this.modalBody = 'Are you sure you want to save changes in this Type Accepted application?';
          this.modalConfirmAction = () => {
            this.setState({requestInProcess: true}, () => {
              http.post(componentAPI.componentInfo(applicationId), data)
                .then(({data}) => {
                  this.someDataWasInputted = false;
                  NotificationManager.success(1, 'Your changes were saved successfully.');
                  updateComponentListEntry({}, data);
                })
                .finally(() => {
                  this._closeModal();
                  user.goToList();
                });
            });
          }
          this._openModal();
        })
    } else {
      user.goToList();
    }
  };

  validateForm = () => {
    const {componentTypeFieldValues, componentTestReports, family} = this.state;
    const {fieldsList, applicationStatus} = this.props;
    let {inputErrors} = this.state;

    const isEmptyArray = object => {
      return object.length !== undefined && typeof object === 'object' && !object.length;
    };

    const isEmptyString = object => {
      return !object.length && typeof object === 'string' && !object.length;
    };

    const isEmptyObject = object => {
      return object.length === undefined && typeof object === 'object' && !Object.keys(object).length;
    };

    this.requiredFields.forEach(fieldName => {
      if (isEmptyString(this.state[fieldName]) || isEmptyArray(this.state[fieldName]) || isEmptyObject(this.state[fieldName])) inputErrors[fieldName] = true;
    });

    for (let key of Object.keys(componentTypeFieldValues)) {
      const fieldData = fieldsList.find(element => element.id === componentTypeFieldValues[key].componentTypeFieldId);
      if (fieldData.required &&
          (isEmptyString(componentTypeFieldValues[key].componentTypeFieldValue) || isEmptyArray(componentTypeFieldValues[key].componentTypeFieldValue) || isEmptyObject(componentTypeFieldValues[key].componentTypeFieldValue))) {
        inputErrors[key] = true;
      }
    }

    return new Promise((resolve, reject) => {this.setState({inputErrors}, () => {
      if (Object.keys(this.state.inputErrors).length) {
        NotificationManager.error('note', 'Cannot submit the application.', 'Please check you information and try again.');
        reject();
      } else if (isEmptyArray(componentTestReports) && !family && applicationStatus !== STATUS.DEACTIVATED && !this.componentHadFamily) {
        NotificationManager.error('note', 'Cannot submit the application.', 'Select Family or upload at least one individual report file.');
        reject();
      } else {
        resolve();
      }
    });});
  };

  handleRemoveFile = index => () => {
    const {componentTestReports} = this.state;

    this.someDataWasInputted = true;
    if (componentTestReports[index].created) {
      this.filesIdsToDelete.push(componentTestReports[index].id);
    }

    this.setState(prevState => {
      prevState.componentTestReports.splice(index, 1);
      return {componentTestReports: prevState.componentTestReports};
    });
  };

  handleFileSelect = files => {
    this.someDataWasInputted = true;
    this.setState(prevState => ({
      componentTestReports: [...prevState.componentTestReports, ...files]
    }));
  };

  handleAdditionalInputChange = index => event => {
    let {componentTypeFieldValues, inputErrors} = this.state;

    this.someDataWasInputted = true;
    delete inputErrors[index];

    const newValue = event.target ? event.target.value : event.value || event;
    componentTypeFieldValues[index].componentTypeFieldValue = newValue;

    this.setState({componentTypeFieldValues, inputErrors});
  };

  handleInputChange = name => value => {
    let {inputErrors} = this.state;

    this.someDataWasInputted = true;
    delete inputErrors[name];

    if (value.length > 251 && name === 'description') {
      inputErrors[name] = 'Description must be 250 characters max';
      this.setState({inputErrors});
    } else {
      this.setState({[name]: value, inputErrors});
    }
  };

  handleSelectFamily = family => {
    let {inputErrors} = this.state;

    this.someDataWasInputted = true;
    delete inputErrors.componentTestReports;

    this.setState({family})
  };

  handleBackButtonClick = () => {
    const {user} = this.props;
    user.goBack();
  };

  _openModal = () => {
    this.setState({isModalOpen: true});
  };

  _closeModal = () => {
    this.setState({isModalOpen: false, requestInProcess: false});
  };

  blockUnconfirmedTransition = location => {
    const {user} = this.props;

    if (this.someDataWasInputted) {
      this.modalBody = 'You have unsaved data. Are you sure you want to exit application without saving?';
      this.modalConfirmAction = () => {
        this.someDataWasInputted = false;
        this._closeModal();
        user.goTo(location);
      };
      this._openModal();
      return false;
    }
    return true;
  };

  render() {
    const {componentTypeFieldValues, description, notes, componentTestReports, family, isModalOpen, inputErrors} = this.state;
    const {
      user,
      match,
      id,
      componentType,
      submissionDate,
      applicationStatus,
      fieldsList,
      categories,
      families,
      familiesRequestInProcess
    } = this.props;
    const {applicationId} = match.params;

    if (this.props.requestInProcess) {
      return (
        <section className='scene__scene-wrapper'>
          <section className='scene__content-wrapper detailsScene__content-wrapper'>
            <Header user={user} loadInProgress={true} />
            <div className='ect-spinner _width_pc_100 _height_120'>
              <div className='ect-spinner__image' />
            </div>
          </section>
        </section>
      )
    } else {
      return (
        <React.Fragment>
          <section className='scene__scene-wrapper'>
            <section className={`scene__content-wrapper detailsScene__content-wrapper ${applicationStatus.toLowerCase()}`}>
              <Header user={user} applicationStatus={applicationStatus} />
              <GeneralInformation
                isUserCanEdit={this.isUserCanEdit()}
                componentTypeFieldValues={componentTypeFieldValues}
                description={description}
                fieldsList={fieldsList}
                id={id}
                type={componentType}
                category={categories.find(cat => cat.id === componentType.categoryId)}
                submissionDate={submissionDate}
                handleAdditionalInputChange={this.handleAdditionalInputChange}
                handleInputChange={this.handleInputChange}
                inputErrors={inputErrors}
              />
              <NotesSection
                user={user}
                notes={notes}
                handleChange={this.handleInputChange('notes')}
              />
              <FamilyInfo
                isEditable={componentType.allowComponentFamily}
                family={family}
                families={families}
                familiesRequestInProcess={familiesRequestInProcess}
                componentType={componentType}
                handleSelectFamily={this.handleSelectFamily} />
              <section className='scene_section'>
                <FilePicker
                  isEditable={this.isUserCanEdit()}
                  editableStateSectionHeader={`Upload Component-specific Test Report${family ? '' : ' *'}`}
                  notEditableStateSectionHeader='Uploaded Component-specific documents'
                  sectionHeaderClassName='scene_section-header'
                  infoMessage='Test reports in this section are component-specific and available for this component only'
                  listSectionId='individual_test_reports'
                  files={componentTestReports}
                  httpParams={{currentId: applicationId,
                    currentMethod: componentAPI.downloadReport,
                    fileIdFieldName:'id',}}
                  handleFileSelect={this.handleFileSelect}
                  handleRemoveFile={this.handleRemoveFile}
                />
              </section>
              <ApplicationActions
                cancelButtonLabel='Cancel'
                saveButtonLabel='Save'
                saveButtonAction={this.handleSubmitClick}
                cancelButtonAction={user.goBack}
              />
            </section>
          </section>

          <Modal isOpen={isModalOpen}>
            <header className='ect-modal-header'>Confirmation</header>
            <div className="ect-modal-body">{this.modalBody}</div>
            <footer className="ect-modal-footer">
              <Button
                label='No'
                type={buttonType.secondary}
                color={buttonColor.gray}
                buttonClassName='_height_40 _width_160'
                onClick={this._closeModal}
              />
              <Button
                label='Yes'
                disabledWithSpinner={this.state.requestInProcess}
                buttonClassName='_height_40 _width_160'
                onClick={this.modalConfirmAction}
              />
            </footer>
          </Modal>
          <Prompt message={this.blockUnconfirmedTransition} />
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Edit/index.jsx